/**
 * At the moment our bad words dataset is a modified
 * version of the offensive words list made available
 * from Carnegie Mellon University School of Computer
 * Science @: https://www.cs.cmu.edu/~biglou/resources/bad-words.txt
 *
 */
const badwords = [
	'abbo',
	'abo',
	'abortion',
	'abuse',
	'addict',
	'addicts',
	'adult',
	'africa',
	'african',
	'alla',
	'alligatorbait',
	'amateur',
	'american',
	'anal',
	'analannie',
	'analsex',
	'angry',
	'anus',
	'arab',
	'arabs',
	'areola',
	'argie',
	'aroused',
	'arse',
	'arsehole',
	'asian',
	'ass',
	'assassin',
	'assassinate',
	'assassination',
	'assault',
	'assbagger',
	'assblaster',
	'assclown',
	'asscowboy',
	'asses',
	'assfuck',
	'assfucker',
	'asshat',
	'asshole',
	'assholes',
	'asshore',
	'assjockey',
	'asskiss',
	'asskisser',
	'assklown',
	'asslick',
	'asslicker',
	'asslover',
	'assman',
	'assmonkey',
	'assmunch',
	'assmuncher',
	'asspacker',
	'asspirate',
	'asspuppies',
	'assranger',
	'asswhore',
	'asswipe',
	'athletesfoot',
	'attack',
	'australian',
	'babe',
	'babies',
	'backdoor',
	'backdoorman',
	'backseat',
	'badfuck',
	'balllicker',
	'balls',
	'ballsack',
	'banging',
	'baptist',
	'barelylegal',
	'barf',
	'barface',
	'barfface',
	'bast',
	'bastard',
	'bazongas',
	'bazooms',
	'beaner',
	'beast',
	'beastality',
	'beastial',
	'beastiality',
	'beatoff',
	'beat-off',
	'beatyourmeat',
	'bestial',
	'bestiality',
	'bi',
	'biatch',
	'bible',
	'bicurious',
	'bigass',
	'bigbastard',
	'bigbutt',
	'bigger',
	'bisexual',
	'bi-sexual',
	'bitch',
	'bitcher',
	'bitches',
	'bitchez',
	'bitchin',
	'bitching',
	'bitchslap',
	'bitchy',
	'biteme',
	'blackout',
	'blacks',
	'blind',
	'blow',
	'blowjob',
	'boang',
	'bohunk',
	'bollick',
	'bollock',
	'bomb',
	'bombers',
	'bombing',
	'bombs',
	'bomd',
	'bondage',
	'boner',
	'boob',
	'boobies',
	'boobs',
	'booby',
	'boody',
	'boom',
	'boong',
	'boonga',
	'boonie',
	'booty',
	'bootycall',
	'bountybar',
	'bra',
	'brea5t',
	'breast',
	'breastjob',
	'breastlover',
	'breastman',
	'brothel',
	'bugger',
	'buggered',
	'buggery',
	'bullcrap',
	'bulldike',
	'bulldyke',
	'bullshit',
	'bumblefuck',
	'bumfuck',
	'bunga',
	'bunghole',
	'buried',
	'burn',
	'butchbabes',
	'butchdike',
	'butchdyke',
	'buttbang',
	'butt-bang',
	'buttface',
	'buttfuck',
	'butt-fuck',
	'buttfucker',
	'butt-fucker',
	'buttfuckers',
	'butt-fuckers',
	'butthead',
	'buttman',
	'buttmunch',
	'buttmuncher',
	'buttpirate',
	'buttplug',
	'buttstain',
	'byatch',
	'cacker',
	'cameljockey',
	'cameltoe',
	'canadian',
	'cancer',
	'carpetmuncher',
	'carruth',
	'catholic',
	'catholics',
	'cemetery',
	'chav',
	'cherrypopper',
	'chickslick',
	`children's`,
	'chinaman',
	'chinamen',
	'chinese',
	'chink',
	'chinky',
	'choad',
	'chode',
	'christ',
	'cigarette',
	'cigs',
	'clamdigger',
	'clamdiver',
	'clit',
	'clitoris',
	'clogwog',
	'cocaine',
	'cock',
	'cockblock',
	'cockblocker',
	'cockcowboy',
	'cockfight',
	'cockhead',
	'cockknob',
	'cocklicker',
	'cocklover',
	'cocknob',
	'cockqueen',
	'cockrider',
	'cocksman',
	'cocksmith',
	'cocksmoker',
	'cocksucer',
	'cocksuck',
	'cocksucked',
	'cocksucker',
	'cocksucking',
	'cocktail',
	'cocktease',
	'cocky',
	'coitus',
	'color',
	'colored',
	'coloured',
	'commie',
	'communist',
	'condom',
	'conservative',
	'conspiracy',
	'coolie',
	'cooly',
	'coondog',
	'copulate',
	'cornhole',
	'corruption',
	'cra5h',
	'crabs',
	'crack',
	'crackpipe',
	'crackwhore',
	'crack-whore',
	'crap',
	'crapola',
	'crapper',
	'crappy',
	'crash',
	'creamy',
	'crime',
	'crimes',
	'criminal',
	'criminals',
	'crotch',
	'crotchjockey',
	'crotchmonkey',
	'crotchrot',
	'cum',
	'cumbubble',
	'cumfest',
	'cumjockey',
	'cumm',
	'cummer',
	'cumming',
	'cumquat',
	'cumqueen',
	'cumshot',
	'cunilingus',
	'cunillingus',
	'cunn',
	'cunnilingus',
	'cunntt',
	'cunt',
	'cunteyed',
	'cuntfuck',
	'cuntfucker',
	'cuntlick',
	'cuntlicker',
	'cuntlicking',
	'cuntsucker',
	'cybersex',
	'cyberslimer',
	'dago',
	'dahmer',
	'dammit',
	'damn',
	'damnation',
	'damnit',
	'darkie',
	'darky',
	'datnigga',
	'dead',
	'deapthroat',
	'death',
	'deepthroat',
	'defecate',
	'dego',
	'demon',
	'deposit',
	'destroy',
	'deth',
	'devil',
	'devilworshipper',
	'dickbrain',
	'dickforbrains',
	'dickhead',
	'dickless',
	'dicklick',
	'dicklicker',
	'dickman',
	'dickwad',
	'dickweed',
	'diddle',
	'die',
	'died',
	'dies',
	'dike',
	'dildo',
	'dingleberry',
	'dink',
	'dipshit',
	'dipstick',
	'dirty',
	'disease',
	'diseases',
	'disturbed',
	'dive',
	'dix',
	'dixiedike',
	'dixiedyke',
	'doggiestyle',
	'doggystyle',
	'dong',
	'doodoo',
	'doo-doo',
	'doom',
	'dope',
	'dragqueen',
	'dragqween',
	'dripdick',
	'drug',
	'drunk',
	'drunken',
	'dumb',
	'dumbass',
	'dumbbitch',
	'dumbfuck',
	'dyefly',
	'dyke',
	'easyslut',
	'eatballs',
	'eatme',
	'eatpussy',
	'ecstacy',
	'ejaculate',
	'ejaculated',
	'ejaculating',
	'ejaculation',
	'enema',
	'enemy',
	'erect',
	'erection',
	'ero',
	'escort',
	'ethiopian',
	'ethnic',
	'european',
	'evl',
	'excrement',
	'execute',
	'executed',
	'execution',
	'executioner',
	'explosion',
	'facefucker',
	'faeces',
	'fag',
	'fagging',
	'faggot',
	'fagot',
	'failed',
	'failure',
	'fairies',
	'fairy',
	'fannyfucker',
	'fart',
	'farted',
	'farting',
	'farty',
	'fastfuck',
	'fat',
	'fatah',
	'fatass',
	'fatfuck',
	'fatfucker',
	'fatso',
	'fckcum',
	'feces',
	'felatio',
	'felch',
	'felcher',
	'felching',
	'fellatio',
	'feltch',
	'feltcher',
	'feltching',
	'fetish',
	'fight',
	'filipina',
	'filipino',
	'fingerfood',
	'fingerfuck',
	'fingerfucked',
	'fingerfucker',
	'fingerfuckers',
	'fingerfucking',
	'fire',
	'firing',
	'fistfuck',
	'fistfucked',
	'fistfucker',
	'fistfucking',
	'fisting',
	'flange',
	'flasher',
	'flatulence',
	'floo',
	'flydie',
	'flydye',
	'fok',
	'fondle',
	'footaction',
	'footfuck',
	'footfucker',
	'footlicker',
	'footstar',
	'fore',
	'foreskin',
	'forni',
	'fornicate',
	'foursome',
	'fourtwenty',
	'fraud',
	'freakfuck',
	'freakyfucker',
	'freefuck',
	'fu',
	'fubar',
	'fuc',
	'fucck',
	'fuck',
	'fucka',
	'fuckable',
	'fuckbag',
	'fuckbuddy',
	'fucked',
	'fuckedup',
	'fucker',
	'fuckers',
	'fuckface',
	'fuckfest',
	'fuckfreak',
	'fuckfriend',
	'fuckhead',
	'fuckher',
	'fuckin',
	'fuckina',
	'fucking',
	'fuckingbitch',
	'fuckinnuts',
	'fuckinright',
	'fuckit',
	'fuckknob',
	'fuckme',
	'fuckmehard',
	'fuckmonkey',
	'fuckoff',
	'fuckpig',
	'fucks',
	'fucktard',
	'fuckwhore',
	'fuckyou',
	'fudgepacker',
	'fugly',
	'fuk',
	'fuks',
	'funeral',
	'funfuck',
	'fungus',
	'fuuck',
	'gangbang',
	'gangbanged',
	'gangbanger',
	'gangsta',
	'gatorbait',
	'gaymuthafuckinwhore',
	'gaysex',
	'geez',
	'geezer',
	'geni',
	'genital',
	'getiton',
	'ginzo',
	'gipp',
	'girls',
	'givehead',
	'glazeddonut',
	'gob',
	'god',
	'godammit',
	'goddamit',
	'goddammit',
	'goddamn',
	'goddamned',
	'goddamnes',
	'goddamnit',
	'goddamnmuthafucker',
	'goldenshower',
	'gonorrehea',
	'gonzagas',
	'gook',
	'gotohell',
	'goy',
	'goyim',
	'greaseball',
	'gringo',
	'groe',
	'grostulation',
	'gubba',
	'gummer',
	'gun',
	'gyp',
	'gypo',
	'gypp',
	'gyppie',
	'gyppo',
	'gyppy',
	'hamas',
	'handjob',
	'hapa',
	'hardon',
	'harem',
	'headfuck',
	'headlights',
	'hebe',
	'heeb',
	'hell',
	'henhouse',
	'heroin',
	'herpes',
	'heterosexual',
	'hijack',
	'hijacker',
	'hijacking',
	'hillbillies',
	'hindoo',
	'hiscock',
	'hitler',
	'hitlerism',
	'hitlerist',
	'hiv',
	'ho',
	'hobo',
	'hodgie',
	'hoes',
	'hole',
	'holestuffer',
	'homicide',
	'homo',
	'homobangers',
	'homosexual',
	'honger',
	'honk',
	'honkers',
	'honkey',
	'honky',
	'hookers',
	'hooters',
	'hore',
	'hork',
	'horney',
	'horniest',
	'horny',
	'horseshit',
	'hosejob',
	'hostage',
	'hotdamn',
	'hotpussy',
	'hottotrot',
	'hummer',
	'husky',
	'hussy',
	'hustler',
	'hymen',
	'hymie',
	'iblowu',
	'idiot',
	'ikey',
	'illegal',
	'incest',
	'insest',
	'intercourse',
	'interracial',
	'intheass',
	'inthebuff',
	'israeli',
	`israel's`,
	'italiano',
	'itch',
	'jackass',
	'jackoff',
	'jackshit',
	'jacktheripper',
	'jap',
	'japanese',
	'japcrap',
	'jebus',
	'jeez',
	'jerkoff',
	'jesuschrist',
	'jew',
	'jewish',
	'jiga',
	'jigaboo',
	'jigg',
	'jigga',
	'jiggabo',
	'jigger',
	'jiggy',
	'jihad',
	'jijjiboo',
	'jimfish',
	'jism',
	'jiz',
	'jizim',
	'jizjuice',
	'jizm',
	'jizz',
	'jizzim',
	'jizzum',
	'joint',
	'juggalo',
	'jugs',
	'junglebunny',
	'kaffer',
	'kaffir',
	'kaffre',
	'kafir',
	'kanake',
	'kid',
	'kigger',
	'kike',
	'kill',
	'killed',
	'killer',
	'killing',
	'kills',
	'kink',
	'kinky',
	'kissass',
	'kkk',
	'knife',
	'knockers',
	'kock',
	'kondum',
	'kotex',
	'krap',
	'krappy',
	'kraut',
	'kum',
	'kumbubble',
	'kumbullbe',
	'kummer',
	'kumming',
	'kumquat',
	'kums',
	'kunilingus',
	'kunnilingus',
	'kunt',
	'kyke',
	'lactate',
	'laid',
	'lapdance',
	'latin',
	'lesbain',
	'lesbayn',
	'lesbian',
	'lesbin',
	'lesbo',
	'lez',
	'lezbe',
	'lezbefriends',
	'lezbo',
	'lezz',
	'lezzo',
	'liberal',
	'libido',
	'licker',
	'lickme',
	'limpdick',
	'lingerie',
	'liquor',
	'livesex',
	'loadedgun',
	'looser',
	'loser',
	'lotion',
	'lovebone',
	'lovegoo',
	'lovegun',
	'lovejuice',
	'lovemuscle',
	'lovepistol',
	'loverocket',
	'lowlife',
	'lsd',
	'lubejob',
	'lucifer',
	'luckycammeltoe',
	'macaca',
	'mafia',
	'magicwand',
	'mams',
	'manhater',
	'manpaste',
	'marijuana',
	'mastabate',
	'mastabater',
	'masterbate',
	'masterblaster',
	'mastrabator',
	'masturbate',
	'masturbating',
	'mattressprincess',
	'meatbeatter',
	'meatrack',
	'meth',
	'mexican',
	'mgger',
	'mggor',
	'mickeyfinn',
	'mideast',
	'milf',
	'minority',
	'mockey',
	'mockie',
	'mocky',
	'mofo',
	'moky',
	'moles',
	'molest',
	'molestation',
	'molester',
	'molestor',
	'moneyshot',
	'mooncricket',
	'mormon',
	'moron',
	'moslem',
	'mosshead',
	'mothafuck',
	'mothafucka',
	'mothafuckaz',
	'mothafucked',
	'mothafucker',
	'mothafuckin',
	'mothafucking',
	'mothafuckings',
	'motherfuck',
	'motherfucked',
	'motherfucker',
	'motherfuckin',
	'motherfucking',
	'motherfuckings',
	'motherlovebone',
	'muff',
	'muffdive',
	'muffdiver',
	'muffindiver',
	'mufflikcer',
	'murder',
	'murderer',
	'muslim',
	'naked',
	'narcotic',
	'nasty',
	'nastybitch',
	'nastyho',
	'nastyslut',
	'nastywhore',
	'nazi',
	'necro',
	'negro',
	'negroes',
	'negroid',
	`negro's`,
	'nig',
	'niger',
	'nigerian',
	'nigerians',
	'nigg',
	'nigga',
	'niggah',
	'niggaracci',
	'niggard',
	'niggarded',
	'niggarding',
	'niggardliness',
	`niggardliness's`,
	'niggardly',
	'niggards',
	`niggard's`,
	'niggaz',
	'nigger',
	'niggerhead',
	'niggerhole',
	'niggers',
	`nigger's`,
	'niggle',
	'niggled',
	'niggles',
	'niggling',
	'nigglings',
	'niggor',
	'niggur',
	'niglet',
	'nignog',
	'nigr',
	'nigra',
	'nigre',
	'nip',
	'nipple',
	'nipplering',
	'nittit',
	'nlgger',
	'nlggor',
	'nofuckingway',
	'nook',
	'nookey',
	'nookie',
	'noonan',
	'nooner',
	'nude',
	'nudger',
	'nuke',
	'nutfucker',
	'nymph',
	'ontherag',
	'oral',
	'orga',
	'orgasim',
	'orgasm',
	'orgies',
	'orgy',
	'osama',
	'paki',
	'palesimian',
	'palestinian',
	'pansies',
	'pansy',
	'panti',
	'panties',
	'payo',
	'pearlnecklace',
	'pecker',
	'peckerwood',
	'pee',
	'peehole',
	'pee-pee',
	'peepshow',
	'peepshpw',
	'pendy',
	'penetration',
	'peni5',
	'penile',
	'penis',
	'penises',
	'penthouse',
	'period',
	'perv',
	'phonesex',
	'phuk',
	'phuked',
	'phuking',
	'phukked',
	'phukking',
	'phungky',
	'phuq',
	'pi55',
	'picaninny',
	'piccaninny',
	'pickaninny',
	'piker',
	'pikey',
	'piky',
	'pimp',
	'pimped',
	'pimper',
	'pimpjuic',
	'pimpjuice',
	'pimpsimp',
	'pindick',
	'piss',
	'pissed',
	'pisser',
	'pisses',
	'pisshead',
	'pissin',
	'pissing',
	'pissoff',
	'pistol',
	'pixie',
	'pixy',
	'playboy',
	'playgirl',
	'pocha',
	'pocho',
	'pocketpool',
	'pohm',
	'polack',
	'pom',
	'pommie',
	'poo',
	'poon',
	'poontang',
	'poop',
	'pooper',
	'pooperscooper',
	'pooping',
	'poorwhitetrash',
	'popimp',
	'porchmonkey',
	'porn',
	'pornflick',
	'pornking',
	'porno',
	'pornography',
	'pornprincess',
	'pot',
	'poverty',
	'premature',
	'pric',
	'prick',
	'prickhead',
	'primetime',
	'propaganda',
	'pros',
	'prostitute',
	'protestant',
	'pu55i',
	'pu55y',
	'pube',
	'pubic',
	'pubiclice',
	'pud',
	'pudboy',
	'pudd',
	'puddboy',
	'puke',
	'puntang',
	'purinapricness',
	'puss',
	'pussie',
	'pussies',
	'pussy',
	'pussycat',
	'pussyeater',
	'pussyfucker',
	'pussylicker',
	'pussylips',
	'pussylover',
	'pussypounder',
	'pusy',
	'quashie',
	'queef',
	'queer',
	'quickie',
	'quim',
	'ra8s',
	'rabbi',
	'racial',
	'racist',
	'radical',
	'radicals',
	'raghead',
	'rape',
	'raped',
	'raper',
	'rapist',
	'rearend',
	'rearentry',
	'rectum',
	'redlight',
	'redneck',
	'reefer',
	'reestie',
	'refugee',
	'reject',
	'remains',
	'rentafuck',
	'republican',
	'rere',
	'retard',
	'retarded',
	'ribbed',
	'rigger',
	'rimjob',
	'rimming',
	'robber',
	'roundeye',
	'rump',
	'russki',
	'russkie',
	'sadis',
	'sadom',
	'samckdaddy',
	'sandm',
	'sandnigger',
	'satan',
	'scag',
	'scallywag',
	'scat',
	'schlong',
	'screw',
	'screwyou',
	'scrotum',
	'scum',
	'semen',
	'seppo',
	'servant',
	'sex',
	'sexed',
	'sexfarm',
	'sexhound',
	'sexhouse',
	'sexing',
	'sexkitten',
	'sexpot',
	'sexslave',
	'sextogo',
	'sextoy',
	'sextoys',
	'sexual',
	'sexually',
	'sexwhore',
	'sexy',
	'sexymoma',
	'sexy-slim',
	'shag',
	'shaggin',
	'shagging',
	'shat',
	'shav',
	'shawtypimp',
	'sheeney',
	'shhit',
	'shinola',
	'shit',
	'shitcan',
	'shitdick',
	'shite',
	'shiteater',
	'shited',
	'shitface',
	'shitfaced',
	'shitfit',
	'shitforbrains',
	'shitfuck',
	'shitfucker',
	'shitfull',
	'shithapens',
	'shithappens',
	'shithead',
	'shithouse',
	'shiting',
	'shitlist',
	'shitola',
	'shitoutofluck',
	'shits',
	'shitstain',
	'shitted',
	'shitter',
	'shitting',
	'shitty',
	'shoot',
	'shooting',
	'shortfuck',
	'showtime',
	'sick',
	'sixsixsix',
	'sixtynine',
	'sixtyniner',
	'skank',
	'skankbitch',
	'skankfuck',
	'skankwhore',
	'skanky',
	'skankybitch',
	'skankywhore',
	'skinflute',
	'skum',
	'skumbag',
	'slant',
	'slanteye',
	'slapper',
	'slav',
	'slave',
	'slavedriver',
	'sleezebag',
	'sleezeball',
	'slideitin',
	'slime',
	'slimeball',
	'slimebucket',
	'slopehead',
	'slopey',
	'slopy',
	'slut',
	'sluts',
	'slutt',
	'slutting',
	'slutty',
	'slutwear',
	'slutwhore',
	'smack',
	'smackthemonkey',
	'smut',
	'snatch',
	'snatchpatch',
	'snigger',
	'sniggered',
	'sniggering',
	'sniggers',
	`snigger's`,
	'sniper',
	'snot',
	'snowback',
	'snownigger',
	'sob',
	'sodom',
	'sodomise',
	'sodomite',
	'sodomize',
	'sodomy',
	'sonofabitch',
	'sonofbitch',
	'sooty',
	'sos',
	'soviet',
	'spaghettibender',
	'spaghettinigger',
	'spank',
	'spankthemonkey',
	'sperm',
	'spermacide',
	'spermbag',
	'spermhearder',
	'spermherder',
	'spic',
	'spick',
	'spig',
	'spigotty',
	'spik',
	'spit',
	'spitter',
	'splittail',
	'spooge',
	'spreadeagle',
	'spunk',
	'spunky',
	'squaw',
	'stiffy',
	'strapon',
	'stringer',
	'stripclub',
	'stroke',
	'stroking',
	'stupid',
	'stupidfuck',
	'stupidfucker',
	'suck',
	'suckdick',
	'sucker',
	'suckme',
	'suckmyass',
	'suckmydick',
	'suckmytit',
	'suckoff',
	'suicide',
	'swallow',
	'swallower',
	'swalow',
	'swastika',
	'sweetness',
	'syphilis',
	'taboo',
	'taff',
	'tampon',
	'tantra',
	'tarbaby',
	'tard',
	'teat',
	'terror',
	'terrorist',
	'teste',
	'testicle',
	'testicles',
	'thicklips',
	'thirdeye',
	'thirdleg',
	'threesome',
	'threeway',
	'timbernigger',
	'tinkle',
	'tit',
	'titbitnipply',
	'titfuck',
	'titfucker',
	'titfuckin',
	'titjob',
	'titlicker',
	'titlover',
	'tits',
	'tittie',
	'titties',
	'titty',
	'tnt',
	'toilet',
	'tongethruster',
	'tongue',
	'tonguethrust',
	'tonguetramp',
	'tortur',
	'torture',
	'tosser',
	'towelhead',
	'trailertrash',
	'tramp',
	'trannie',
	'tranny',
	'transexual',
	'transsexual',
	'transvestite',
	'triplex',
	'trisexual',
	'trojan',
	'trots',
	'tuckahoe',
	'tunneloflove',
	'turd',
	'turnon',
	'twat',
	'twink',
	'twinkie',
	'twobitwhore',
	'uck',
	'uk',
	'unfuckable',
	'upskirt',
	'uptheass',
	'upthebutt',
	'urinary',
	'urinate',
	'urine',
	'usama',
	'uterus',
	'vagina',
	'vaginal',
	'vatican',
	'vibr',
	'vibrater',
	'vibrator',
	'vietcong',
	'violence',
	'virgin',
	'virginbreaker',
	'vomit',
	'vulva',
	'wab',
	'wank',
	'wanker',
	'wanking',
	'waysted',
	'weapon',
	'weenie',
	'weewee',
	'welfare',
	'wetb',
	'wetback',
	'wetspot',
	'whacker',
	'whash',
	'whigger',
	'whiskey',
	'whiskeydick',
	'whiskydick',
	'whit',
	'whitenigger',
	'whites',
	'whitetrash',
	'whitey',
	'whiz',
	'whop',
	'whore',
	'whorefucker',
	'whorehouse',
	'wigger',
	'williewanker',
	'wn',
	'wog',
	`women's`,
	'wop',
	'wtf',
	'wuss',
	'wuzzie',
	'xtc',
	'xxx',
	'yankee',
	'yellowman',
	'zigabo',
	'zipperhead',
	'aasyslut',
	'aatpussy',
	'acefucker',
	'ackass',
	'ackshit',
	'adfuck',
	'andnigger',
	'annyfucker',
	'asasasasasshole',
	'asasasasshole',
	'asasasshole',
	'asasshole',
	'asfuck',
	'asfucker',
	'assaolt',
	'assas',
	'assassen',
	'assassenate',
	'assassenateon',
	'assassi',
	'assassinat',
	'assassinata',
	'assassinatio',
	'assassinatiun',
	'assaul',
	'assbaggar',
	'assbagge',
	'assblastar',
	'assblaste',
	'assclow',
	'asscluwn',
	'asscowbo',
	'asscuwbuy',
	'asse',
	'assfock',
	'assfocker',
	'assfuc',
	'assfuckar',
	'assfucke',
	'assha',
	'asshhhhhhole',
	'asshhhhhole',
	'asshhhhole',
	'asshhhole',
	'asshhole',
	'asshohohohohole',
	'asshohohohole',
	'asshohohole',
	'asshohole',
	'asshol',
	'asshola',
	'assholas',
	'assholele',
	'assholelele',
	'assholelelele',
	'assholelelelele',
	'assholle',
	'asshollle',
	'assholllle',
	'asshollllle',
	'assholllllle',
	'assholole',
	'asshololole',
	'assholololole',
	'asshololololole',
	'asshor',
	'asshora',
	'asshshole',
	'asshshshole',
	'asshshshshole',
	'asshshshshshole',
	'asshule',
	'asshules',
	'asshure',
	'assjockay',
	'assjocke',
	'assjuckey',
	'asskess',
	'asskesser',
	'asskis',
	'asskissar',
	'asskisse',
	'assklow',
	'asskluwn',
	'assleck',
	'asslecker',
	'asslic',
	'asslickar',
	'asslicke',
	'asslovar',
	'asslove',
	'assluver',
	'assma',
	'assmonch',
	'assmoncher',
	'assmonkay',
	'assmonke',
	'assmunc',
	'assmunchar',
	'assmunche',
	'assmunkey',
	'asspackar',
	'asspacke',
	'assperate',
	'asspirat',
	'asspirata',
	'asspoppies',
	'asspuppees',
	'asspuppias',
	'asspuppie',
	'assrangar',
	'assrange',
	'assshole',
	'asssshole',
	'assssshole',
	'asssssshole',
	'assssssshole',
	'asssssssshole',
	'asssssssssshole',
	'asswepe',
	'asswhor',
	'asswhora',
	'asswhure',
	'asswip',
	'asswipa',
	'astfuck',
	'astybitch',
	'astyslut',
	'astywhore',
	'aswhore',
	'asyslut',
	'atass',
	'atfuck',
	'atfucker',
	'atnigga',
	'atpussy',
	'aymuthafuckinwhore',
	'bababababastard',
	'babababastard',
	'bababastard',
	'babastard',
	'basssssstard',
	'bassssstard',
	'basssstard',
	'bassstard',
	'basstard',
	'bastard',
	'bastardd',
	'bastarddd',
	'bastardddd',
	'bastarddddd',
	'bastardddddd',
	'bastardrd',
	'bastardrdrd',
	'bastardrdrdrd',
	'bastardrdrdrdrd',
	'bbastard',
	'bbbastard',
	'bbbbastard',
	'bbbbbastard',
	'bbbbbbastard',
	'bbbbbbitch',
	'bbbbbitch',
	'bbbbitch',
	'bbbitch',
	'bbitch',
	'bedfuck',
	'begass',
	'begbastard',
	'bibibibibitch',
	'bibibibitch',
	'bibibitch',
	'bibitch',
	'bitchar',
	'bitchas',
	'bitchaz',
	'bitchch',
	'bitchchch',
	'bitchchchch',
	'bitchchchchch',
	'bitche',
	'bitchh',
	'bitchhh',
	'bitchhhh',
	'bitchhhhh',
	'bitchhhhhh',
	'bitchi',
	'bitchsla',
	'bitchslep',
	'bollshit',
	'bulshit',
	'bumblafuck',
	'but-fuck',
	'but-fucker',
	'but-fuckers',
	'butfuck',
	'butfucker',
	'butfuckers',
	'butt-fuckar',
	'butt-fuckars',
	'butt-fucke',
	'buttfuckar',
	'buttfuckars',
	'buttfucke',
	'ccccccunt',
	'cccccunt',
	'ccccunt',
	'cccunt',
	'ccunt',
	'creck-whore',
	'creckwhore',
	'cucucucucunt',
	'cucucucunt',
	'cucucunt',
	'cucunt',
	'cuntayad',
	'cunteye',
	'cuntfuc',
	'cuntfuckar',
	'cuntfucke',
	'cuntleck',
	'cuntleckeng',
	'cuntlecker',
	'cuntlick',
	'cuntlickar',
	'cuntlicker',
	'cuntlicking',
	'cuntnt',
	'cuntntnt',
	'cuntntntnt',
	'cuntntntntnt',
	'cuntsuckar',
	'cuntsucke',
	'cuntt',
	'cunttt',
	'cuntttt',
	'cunttttt',
	'cuntttttt',
	'datnigg',
	'detnigge',
	'dickbrai',
	'dickbrein',
	'dickforbrain',
	'dickforbreins',
	'dickfurbrains',
	'dickhaad',
	'dickhea',
	'dickheed',
	'dicklic',
	'dicklickar',
	'dicklicke',
	'dickma',
	'dickmen',
	'dickwa',
	'dickwaad',
	'dickwed',
	'dickwee',
	'didick',
	'dididick',
	'didididick',
	'dididididick',
	'dombass',
	'dombbitch',
	'dumbitch',
	'eadfuck',
	'eesyslut',
	'eetpussy',
	'entafuck',
	'entheass',
	'essfuck',
	'essfucker',
	'esswhore',
	'exwhore',
	'facafuckar',
	'facefucke',
	'fafafafaggot',
	'fafafaggot',
	'fafaggot',
	'fagagagaggot',
	'fagagaggot',
	'fagaggot',
	'faggeng',
	'faggggggggot',
	'faggggggot',
	'fagggggot',
	'faggggot',
	'fagggot',
	'faggin',
	'faggo',
	'faggogogogot',
	'faggogogot',
	'faggogot',
	'faggotot',
	'faggototot',
	'faggotototot',
	'faggott',
	'faggottt',
	'faggotttt',
	'faggottttt',
	'faggut',
	'faging',
	'fago',
	'fagut',
	'fannyfuckar',
	'fannyfucke',
	'fanyfucker',
	'fatfuckar',
	'fatfucke',
	'fecefucker',
	'fengerfuck',
	'fengerfucked',
	'fengerfuckeng',
	'fengerfucker',
	'fengerfuckers',
	'fennyfucker',
	'festfuck',
	'festfucked',
	'festfuckeng',
	'festfucker',
	'fetfuck',
	'fetfucker',
	'ffaggot',
	'fffaggot',
	'ffffaggot',
	'fffffaggot',
	'ffffffuck',
	'fffffuck',
	'ffffuck',
	'fffuck',
	'ffuck',
	'fingarfuck',
	'fingarfuckad',
	'fingarfuckar',
	'fingarfuckars',
	'fingarfucking',
	'fingerfuck',
	'fingerfucked',
	'fingerfucker',
	'fingerfucking',
	'fistfuckad',
	'fistfuckar',
	'fistfucked',
	'fistfucker',
	'fistfucking',
	'fockingbitch',
	'fockwhore',
	'footfuckar',
	'footfucke',
	'fotfuck',
	'fotfucker',
	'fraafuck',
	'fraakfuck',
	'fraakyfuckar',
	'freakyfucke',
	'freekfuck',
	'freekyfucker',
	'frefuck',
	'fuckabl',
	'fuckabla',
	'fuckad',
	'fuckadup',
	'fuckar',
	'fuckars',
	'fuckba',
	'fuckbeg',
	'fuckbudd',
	'fuckbudy',
	'fuckck',
	'fuckckck',
	'fuckckckck',
	'fuckckckckck',
	'fucke',
	'fuckeble',
	'fuckedu',
	'fucken',
	'fuckena',
	'fuckeng',
	'fuckengbetch',
	'fuckennuts',
	'fuckenreght',
	'fucket',
	'fuckfac',
	'fuckfaca',
	'fuckfast',
	'fuckfece',
	'fuckfes',
	'fuckfraak',
	'fuckfrea',
	'fuckfreek',
	'fuckfreend',
	'fuckfriand',
	'fuckfrien',
	'fuckhaad',
	'fuckhar',
	'fuckhe',
	'fuckhea',
	'fuckheed',
	'fucki',
	'fuckine',
	'fuckingbitc',
	'fuckinnut',
	'fuckinrigh',
	'fuckinuts',
	'fuckk',
	'fuckkk',
	'fuckkkk',
	'fuckkkkk',
	'fuckkkkkk',
	'fuckkno',
	'fuckknub',
	'fuckma',
	'fuckmahard',
	'fuckme',
	'fuckmehar',
	'fuckmeherd',
	'fuckmonkay',
	'fuckmonke',
	'fuckmunkey',
	'fucknob',
	'fuckof',
	'fuckpeg',
	'fuckpi',
	'fucktar',
	'fuckterd',
	'fuckuff',
	'fuckwhor',
	'fuckwhora',
	'fuckwhure',
	'fuckyo',
	'fuckyuu',
	'fufuck',
	'fufufuck',
	'fufufufuck',
	'fufufufufuck',
	'fuutfuck',
	'fuutfucker',
	'gaymothafockinwhore',
	'gaymuthafuckenwhore',
	'gaymuthafuckinwhor',
	'gaymuthafuckinwhora',
	'gaymuthafuckinwhure',
	'geymuthefuckinwhore',
	'godamnmuthafucker',
	'goddamnmuthafuckar',
	'goddamnmuthafucke',
	'goddemnmuthefucker',
	'guddamnmuthafucker',
	'haadfuck',
	'heedfuck',
	'hiskeydick',
	'hiskydick',
	'hitdick',
	'hitenigger',
	'hitfuck',
	'hitfucker',
	'horefucker',
	'horsashit',
	'hortfuck',
	'hurseshit',
	'hutpussy',
	'igass',
	'igbastard',
	'imbernigger',
	'impdick',
	'indick',
	'ingerfuck',
	'ingerfucked',
	'ingerfucker',
	'ingerfuckers',
	'ingerfucking',
	'inthaass',
	'ipshit',
	'issass',
	'istfuck',
	'istfucked',
	'istfucker',
	'istfucking',
	'itfuck',
	'itfucker',
	'itfuckin',
	'jeckshit',
	'kankbitch',
	'kankfuck',
	'kankwhore',
	'kankybitch',
	'kankywhore',
	'kessass',
	'mattrassprincass',
	'mothafuckad',
	'mothafuckar',
	'mothafucke',
	'mothafucked',
	'mothafucken',
	'mothafuckeng',
	'mothafuckengs',
	'mothafucki',
	'mothafucking',
	'motharfuck',
	'motharfuckad',
	'motharfuckar',
	'motharfuckin',
	'motharfucking',
	'motharfuckings',
	'mothefuck',
	'mothefucke',
	'mothefucked',
	'mothefucker',
	'mothefuckez',
	'mothefuckin',
	'mothefucking',
	'mothefuckings',
	'motherfucke',
	'motherfucken',
	'motherfuckeng',
	'motherfuckengs',
	'motherfucki',
	'muthafuck',
	'muthafucka',
	'muthafuckaz',
	'muthafucked',
	'muthafucker',
	'muthafuckin',
	'muthafucking',
	'muthafuckings',
	'mutherfuck',
	'mutherfucked',
	'mutherfucker',
	'mutherfuckin',
	'mutherfucking',
	'mutherfuckings',
	'nestybitch',
	'nestyslut',
	'nestywhore',
	'nfuckable',
	'niggaga',
	'niggagaga',
	'niggagagaga',
	'niggar',
	`niggar's`,
	'niggaracc',
	'niggard',
	'niggardad',
	'niggarde',
	'niggardin',
	'niggardl',
	'niggardlinass',
	`niggardlinass's`,
	'niggardlines',
	'niggardliness',
	'niggarhaad',
	'niggarhola',
	'niggars',
	'nigge',
	'niggegegeger',
	'niggegeger',
	'niggeger',
	'niggeh',
	'nigger',
	'niggerd',
	`niggerd's`,
	'niggerded',
	'niggerding',
	'niggerdliness',
	`niggerdliness's`,
	'niggerdly',
	'niggerds',
	'niggerecci',
	'niggered',
	'niggerer',
	'niggererer',
	'niggerererer',
	'niggerhea',
	'niggerheed',
	'niggerhol',
	'niggerhule',
	'niggering',
	'niggerr',
	'niggerrr',
	'niggerrrr',
	'niggerrrrr',
	'niggez',
	'niggga',
	'niggger',
	'nigggga',
	'nigggger',
	'niggggga',
	'niggggger',
	'nigggggga',
	'nigggggger',
	'nigggggggga',
	'nigggggggger',
	'niggl',
	'niggla',
	'nigglad',
	'nigglas',
	'nigglin',
	'niggo',
	'niggu',
	'ninigga',
	'ninigger',
	'nininigga',
	'nininigger',
	'ninininigga',
	'ninininigger',
	'nnigga',
	'nnigger',
	'nnnigga',
	'nnnigger',
	'nnnnigga',
	'nnnnigger',
	'nnnnnigga',
	'nnnnnigger',
	'nofuckengway',
	'nofuckingwa',
	'nofuckingwey',
	'nownigger',
	'ntheass',
	'nufuckingway',
	'nutfuckar',
	'nutfucke',
	'oddamnmuthafucker',
	'ofuckingway',
	'onofabitch',
	'onofbitch',
	'ootfuck',
	'ootfucker',
	'optheass',
	'orseshit',
	'othafuck',
	'othafucka',
	'othafuckaz',
	'othafucked',
	'othafucker',
	'othafuckin',
	'othafucking',
	'othafuckings',
	'otherfuck',
	'otherfucked',
	'otherfucker',
	'otherfuckin',
	'otherfucking',
	'otherfuckings',
	'otpussy',
	'paghettinigger',
	'pornprincass',
	'ppppppussy',
	'pppppussy',
	'ppppussy',
	'pppussy',
	'ppussy',
	'ptheass',
	'pupupupupussy',
	'pupupupussy',
	'pupupussy',
	'pupussy',
	'purinapricnass',
	'pussyaatar',
	'pussyca',
	'pussycet',
	'pussyeate',
	'pussyeeter',
	'pussyfuckar',
	'pussyfucke',
	'pussylecker',
	'pussyleps',
	'pussylickar',
	'pussylicke',
	'pussylip',
	'pussylovar',
	'pussylove',
	'pussyluver',
	'pussypoundar',
	'pussypounde',
	'pussypuunder',
	'pussysy',
	'pussysysy',
	'pussysysysy',
	'pussysysysysy',
	'pussyy',
	'pussyyy',
	'pussyyyy',
	'pussyyyyy',
	'pussyyyyyy',
	'pusyfucker',
	'rack-whore',
	'rackwhore',
	'rantafuck',
	'reakfuck',
	'reakyfucker',
	'reefuck',
	'rentefuck',
	'ripdick',
	'sandniggar',
	'sandnigge',
	'sendnigger',
	'shetfuck',
	'shetfucker',
	'shita',
	'shitaatar',
	'shitad',
	'shitca',
	'shitcen',
	'shitdic',
	'shiteate',
	'shiteeter',
	'shiter',
	'shitfac',
	'shitfaca',
	'shitfacad',
	'shitfece',
	'shitfeced',
	'shitfi',
	'shitfock',
	'shitfocker',
	'shitfoll',
	'shitforbrain',
	'shitforbreins',
	'shitfuc',
	'shitfuckar',
	'shitfucke',
	'shitful',
	'shitfurbrains',
	'shithaad',
	'shithapans',
	'shithapen',
	'shithappans',
	'shithappen',
	'shithea',
	'shitheed',
	'shithepens',
	'shitheppens',
	'shithoose',
	'shithous',
	'shithousa',
	'shithuuse',
	'shitin',
	'shitit',
	'shititit',
	'shitititit',
	'shititititit',
	'shitlis',
	'shitol',
	'shitole',
	'shitootoflock',
	'shitoutofluc',
	'shitstai',
	'shitstein',
	'shitt',
	'shittad',
	'shittar',
	'shitte',
	'shittin',
	'shittt',
	'shitttt',
	'shittttt',
	'shitttttt',
	'shitty',
	'shitula',
	'shituutufluck',
	'shity',
	'shshit',
	'shshshit',
	'shshshshit',
	'shshshshshit',
	'shurtfuck',
	'skenkbitch',
	'skenkfuck',
	'skenkwhore',
	'skenkybitch',
	'skenkywhore',
	'slotwhore',
	'sluting',
	'slutteng',
	'sluttin',
	'slutwaar',
	'slutwea',
	'slutweer',
	'slutwhor',
	'slutwhora',
	'slutwhure',
	'sluty',
	'sniggar',
	`sniggar's`,
	'sniggarad',
	'sniggaring',
	'sniggars',
	'snigge',
	'snigger',
	'sniggere',
	'sniggerin',
	'snowniggar',
	'snownigge',
	'snuwnigger',
	'sockdick',
	'sockmyass',
	'sockmydick',
	'sonofebitch',
	'spaghattiniggar',
	'spaghettinigge',
	'speghettinigger',
	'ssassin',
	'ssassinate',
	'ssassination',
	'ssfuck',
	'ssfucker',
	'sshit',
	'ssshit',
	'sssshit',
	'ssssshit',
	'sssssshit',
	'sswhore',
	'stupedfuck',
	'stupedfucker',
	'stupidfuckar',
	'stupidfucke',
	'sunufabitch',
	'sunufbitch',
	'swaatnass',
	'tetfuck',
	'tetfucken',
	'tetfucker',
	'timbarniggar',
	'timbernigge',
	'titfuckar',
	'titfucke',
	'titfucki',
	'tupidfuck',
	'tupidfucker',
	'twobetwhore',
	'uckdick',
	'uckingbitch',
	'uckmyass',
	'uckmydick',
	'uckwhore',
	'ullshit',
	'umbass',
	'umbbitch',
	'umbfuck',
	'umblefuck',
	'umfuck',
	'unfuck',
	'unfuckabl',
	'unfuckabla',
	'unfuckeble',
	'untfuck',
	'untfucker',
	'upthaass',
	'ussyfucker',
	'utfucker',
	'utt-fuck',
	'utt-fucker',
	'utt-fuckers',
	'uttfuck',
	'uttfucker',
	'uttfuckers',
	'whiskaydick',
	'whitaniggar',
	'whitenigge',
	'whorafuckar',
	'whorefocker',
	'whorefucke',
	'whorehoose',
	'whorehous',
	'whorere',
	'whorerere',
	'whorererere',
	'whorerererere',
	'whurefucker',
	'whwhore',
	'whwhwhore',
	'whwhwhwhore',
	'whwhwhwhwhore',
	'wobitwhore',
	'wwhore',
	'wwwhore',
	'wwwwhore',
	'wwwwwhore',
	'wwwwwwhore',
];

export default badwords;
